import React, { useState, useEffect } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import MainMenu from "./components/MainMenu/MainMenu";
import CarView from "./components/CarView/CarView";
import CarForm from "./components/CarForm/CarForm";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import CarFormConfirm from "./components/CarFormConfirm/CarFormConfirm";

import "./App.css";

function App() {
  const history = createBrowserHistory();
  history.listen(_ => {
    window.scrollTo(0, 0);
  });
  return (
    <div>
      <BrowserRouter basename="/prana/" history={history}>
        <ScrollToTop>
          <Switch>
            <Route exact component={MainMenu} />
            <Route path="/carview" component={CarView} />
            <Route path="/carform" component={CarForm} />
            <Route path="/carformconfirm" component={CarFormConfirm} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
